import { supabase } from '@/lib/supabase';

export interface PaymentRecord {
  user_id: string;
  plan_id: string;
  stripe_payment_intent_id?: string;
  stripe_invoice_id?: string;
  amount: number;
  status: 'pending' | 'paid' | 'failed' | 'canceled' | 'refunded';
  payment_method: string;
  description?: string;
  metadata?: any;
}

export class PaymentService {
  /**
   * Registra um novo pagamento no banco de dados
   */
  static async recordPayment(payment: PaymentRecord): Promise<string> {
    try {
      const { data, error } = await supabase.rpc('record_payment', {
        p_user_id: payment.user_id,
        p_plan_id: payment.plan_id,
        p_stripe_payment_intent_id: payment.stripe_payment_intent_id || null,
        p_stripe_invoice_id: payment.stripe_invoice_id || null,
        p_amount: payment.amount,
        p_status: payment.status,
        p_payment_method: payment.payment_method,
        p_description: payment.description || null,
        p_metadata: payment.metadata || null
      });

      if (error) {
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Erro ao registrar pagamento:', error);
      throw error;
    }
  }

  /**
   * Atualiza o status de um pagamento
   */
  static async updatePaymentStatus(paymentId: string, status: string): Promise<boolean> {
    try {
      const { data, error } = await supabase.rpc('update_payment_status', {
        p_payment_id: paymentId,
        p_status: status
      });

      if (error) {
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Erro ao atualizar status do pagamento:', error);
      throw error;
    }
  }

  /**
   * Busca pagamentos de um usuário
   */
  static async getUserPayments(userId: string) {
    try {
      const { data, error } = await supabase
        .from('payments')
        .select(`
          id,
          created_at,
          amount,
          status,
          payment_method,
          description,
          plan_id,
          stripe_payment_intent_id,
          stripe_invoice_id,
          plans (
            title,
            price
          )
        `)
        .eq('user_id', userId)
        .order('created_at', { ascending: false });

      if (error) {
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Erro ao buscar pagamentos do usuário:', error);
      throw error;
    }
  }

  /**
   * Registra pagamento quando checkout é completado (para integrar com Stripe)
   */
  static async recordStripePayment(
    userId: string,
    planId: string,
    paymentIntentId: string,
    amount: number,
    status: string,
    paymentMethod: string
  ): Promise<string> {
    return this.recordPayment({
      user_id: userId,
      plan_id: planId,
      stripe_payment_intent_id: paymentIntentId,
      amount: amount,
      status: status as any,
      payment_method: paymentMethod,
      description: `Pagamento via Stripe - ${paymentMethod}`,
      metadata: {
        source: 'stripe',
        payment_intent_id: paymentIntentId
      }
    });
  }
} 